/* ============================================================
   ByLanette theme JavaScript
   Vanilla JS, geen externe dependencies. Modulair opgebouwd in init-functies.
   ============================================================ */

(function () {
  'use strict';

  /* --------- Helpers --------- */
  function $(selector, scope) {
    return (scope || document).querySelector(selector);
  }
  function $$(selector, scope) {
    return Array.from((scope || document).querySelectorAll(selector));
  }
  function on(el, event, handler) {
    if (!el) return;
    el.addEventListener(event, handler);
  }
  function lockBody(scope) {
    document.body.classList.add(scope);
  }
  function unlockBody(scope) {
    document.body.classList.remove(scope);
  }

  var FOCUSABLE_SELECTOR =
    'a[href], area[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), ' +
    'select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"]), [contenteditable="true"]';

  function getFocusable(container) {
    return $$(FOCUSABLE_SELECTOR, container).filter(function (el) {
      return el.offsetParent !== null || el.getClientRects().length > 0;
    });
  }

  function trapFocus(container, e) {
    var focusable = getFocusable(container);
    if (focusable.length === 0) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  }

  function focusFirst(container) {
    var focusable = getFocusable(container);
    if (focusable.length > 0) focusable[0].focus();
  }

  /* --------- Mobile menu --------- */
  function initMobileMenu() {
    var menu = $('[data-mobile-menu]');
    if (!menu) return;

    var openButtons = $$('[data-mobile-menu-open]');
    var closeButtons = $$('[data-mobile-menu-close]');
    var lastTrigger = null;

    function open(e) {
      lastTrigger = e && e.currentTarget ? e.currentTarget : null;
      menu.classList.add('is-open');
      menu.setAttribute('aria-hidden', 'false');
      lockBody('has-drawer-open');
      openButtons.forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
      requestAnimationFrame(function () { focusFirst(menu); });
    }
    function close() {
      menu.classList.remove('is-open');
      menu.setAttribute('aria-hidden', 'true');
      unlockBody('has-drawer-open');
      openButtons.forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
      if (lastTrigger && typeof lastTrigger.focus === 'function') lastTrigger.focus();
    }

    openButtons.forEach(function (btn) { on(btn, 'click', open); });
    closeButtons.forEach(function (btn) { on(btn, 'click', close); });
    on(document, 'keydown', function (e) {
      if (!menu.classList.contains('is-open')) return;
      if (e.key === 'Escape') { close(); return; }
      if (e.key === 'Tab') trapFocus(menu, e);
    });

    // Submenu uitklappers binnen mobile menu
    $$('[data-mobile-submenu-toggle]', menu).forEach(function (toggle) {
      on(toggle, 'click', function () {
        var bodyId = toggle.getAttribute('aria-controls');
        var body = bodyId ? document.getElementById(bodyId) : null;
        var expanded = toggle.getAttribute('aria-expanded') === 'true';
        toggle.setAttribute('aria-expanded', expanded ? 'false' : 'true');
        if (body) {
          if (expanded) body.setAttribute('hidden', '');
          else body.removeAttribute('hidden');
        }
      });
    });
  }

  /* --------- Cart drawer --------- */
  function initCartDrawer() {
    var drawer = $('[data-cart-drawer]');
    if (!drawer) return;

    var openButtons = $$('[data-cart-drawer-open]');
    var closeButtons = $$('[data-cart-drawer-close]');
    var lastTrigger = null;

    function open(e) {
      lastTrigger = e && e.currentTarget && typeof e.currentTarget.focus === 'function' ? e.currentTarget : lastTrigger;
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      // De winkelmand-knop in de header draagt aria-controls, dus hoort hij ook
      // te vertellen of de lade open staat. Zonder dit hoort een schermlezer
      // alleen dat er iets bestuurd wordt, niet in welke stand het staat.
      openButtons.forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
      lockBody('has-drawer-open');
      requestAnimationFrame(function () { focusFirst(drawer.querySelector('.cart-drawer__panel') || drawer); });
    }
    function close() {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      openButtons.forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
      unlockBody('has-drawer-open');
      if (lastTrigger && typeof lastTrigger.focus === 'function') lastTrigger.focus();
    }

    openButtons.forEach(function (btn) { on(btn, 'click', open); });
    closeButtons.forEach(function (btn) { on(btn, 'click', close); });
    on(document, 'keydown', function (e) {
      if (!drawer.classList.contains('is-open')) return;
      if (e.key === 'Escape') { close(); return; }
      if (e.key === 'Tab') trapFocus(drawer.querySelector('.cart-drawer__panel') || drawer, e);
    });

    // Quick-add knoppen op product-cards en andere "snel toevoegen" plekken
    on(document, 'click', function (e) {
      var btn = e.target.closest('[data-quick-add]');
      if (!btn) return;
      e.preventDefault();
      var variantId = btn.getAttribute('data-variant-id');
      if (!variantId || btn.disabled) return;
      lastTrigger = btn;
      var originalHTML = btn.innerHTML;
      btn.disabled = true;
      btn.classList.add('is-loading');
      var quickAddPromise = addToCart(variantId, 1);
      var quickAddToken = cartMetaToken;
      quickAddPromise
        .then(function (response) {
          // Alleen de sectie-swap doen als er intussen geen nieuwere mutatie is
          // gestart; die zou anders de drawer met een oudere staat overschrijven.
          if (response && response.sections) {
            if (quickAddToken === cartMetaToken) updateCartFromSections(response);
            updateCartMeta();
          } else refreshCart();
          btn.classList.remove('is-loading');
          btn.classList.add('is-added');
          open();
          setTimeout(function () {
            btn.disabled = false;
            btn.classList.remove('is-added');
            btn.innerHTML = originalHTML;
          }, 1200);
        })
        .catch(function (err) {
          btn.classList.remove('is-loading');
          // Net uitverkocht of voorraadlimiet: Shopify geeft 422. Sinds addToCart
          // door cartRespons loopt komt dat hier binnen als fout en niet meer als
          // respons, dus de afhandeling hoort in deze tak. Stond hij in .then, dan
          // was hij dood en zag de klant alleen een knop die terugsprong.
          // Bewust geen cartMutatieFout hier: die schrijft in de voettekst van de
          // lade, en bij quick-add staat die dicht. De knop zelf is de plek waar de
          // klant kijkt, dus het label is hier de melding.
          if (err && err.status === 422) {
            btn.innerHTML = 'Uitverkocht';
            setTimeout(function () {
              btn.disabled = false;
              btn.innerHTML = originalHTML;
            }, 1600);
            return;
          }
          btn.disabled = false;
          btn.innerHTML = originalHTML;
          console.error('Quick-add faalde', err);
        });
    });

    // Cart-mutaties (increment/decrement/remove) via event-delegation
    // Werkt zowel binnen de drawer als op de cart-page.
    // Mutaties lopen serieel door één keten: bij snel klikken leest elke stap
    // de hoeveelheid pas ná de vorige render, zodat er geen lost update ontstaat.
    var cartOpChain = Promise.resolve();
    function queueCartOp(fn) {
      cartOpChain = cartOpChain
        .then(fn, fn)
        .then(function (res) { if (res) handleCartMutationResponse(res); }, function (err) {
          console.warn('Cart-mutatie faalde', err);
          cartMutatieFout(err);
        });
    }
    // Een lopende actie splitst een mandregel in een betaalde en een gratis helft. De
    // weergave voegt die samen tot een rij, de BEDIENING niet: plus en min grijpen aan
    // op de betaalde helft. Nagemeten op 31 augustus 2026: verander een betaalde regel
    // met N, dan verandert het groepstotaal met precies N, want Shopify herverdeelt de
    // gratis stuks daarna zelf.
    //
    // De rij wordt pas op het moment van uitvoeren uit de DOM gelezen, dus uit de
    // opmaak die na de vorige mutatie is ververst. Dat beschermt tegen een sleutel die
    // tussen twee snelle kliks is verouderd, en dat gebeurt hier echt: Shopify
    // documenteert dat een regelsleutel verandert bij een wijziging in de
    // kortingstoekenning.
    function leesGroep(groep) {
      var rij = document.querySelector('[data-cart-group="' + groep + '"]');
      if (!rij) return null;
      return {
        lijn: parseInt(rij.getAttribute('data-cart-line'), 10) || 0,
        aantal: parseInt(rij.getAttribute('data-cart-line-qty'), 10) || 0,
        sleutels: (rij.getAttribute('data-cart-keys') || '').split(' ').filter(Boolean)
      };
    }

    function changeCartLine(lijn, quantity) {
      cartMetaToken++;
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({
          line: lijn,
          quantity: quantity,
          sections: 'cart-drawer-contents,main-cart',
          sections_url: window.location.pathname
        })
      }).then(cartRespons);
    }

    on(document, 'click', function (e) {
      var increment = e.target.closest('[data-cart-increment]');
      var decrement = e.target.closest('[data-cart-decrement]');
      var remove = e.target.closest('[data-cart-remove]');
      if (!increment && !decrement && !remove) return;
      e.preventDefault();

      if (increment) {
        var g1 = increment.getAttribute('data-cart-increment');
        queueCartOp(function () {
          var s = leesGroep(g1);
          if (!s || !s.lijn) return null;
          return changeCartLine(s.lijn, s.aantal + 1);
        });
      } else if (decrement) {
        var g2 = decrement.getAttribute('data-cart-decrement');
        queueCartOp(function () {
          var s = leesGroep(g2);
          if (!s || !s.lijn) return null;
          return changeCartLine(s.lijn, Math.max(0, s.aantal - 1));
        });
      } else if (remove) {
        // Wis haalt de HELE groep weg, in een aanroep. Los na elkaar kan niet: de
        // eerste wijziging verandert de kortingstoekenning en daarmee de sleutel van
        // de tweede.
        var g3 = remove.getAttribute('data-cart-remove');
        queueCartOp(function () {
          var s = leesGroep(g3);
          if (!s || !s.sleutels.length) return null;
          var updates = {};
          s.sleutels.forEach(function (k) { updates[k] = 0; });
          return updateCart(updates);
        });
      }
    });
  }

  function handleCartMutationResponse(response) {
    if (response && response.sections) {
      updateCartFromSections(response);
    } else {
      refreshCart();
    }
  }

  /* --------- Cadeauverpakking --------- */
  // Eén vinkje per regel in de mand, sinds 27 augustus 2026. Daarvoor was het één
  // vinkje voor de hele bestelling plus een keuzelijst met verpakkingen; die keuzelijst
  // had na Netty's ingreep nog maar één optie en de voorselectie mikte op een variant
  // die niet meer bestaat, dus wie de toggle aanzette kreeg niets in zijn mand.
  //
  // De koppeling tussen een product en zijn verpakking staat op de
  // CADEAUVERPAKKING-regel (property `_variant` = het variant-id van het product) en
  // niet als property op het product. Reden staat in de Ajax Cart API-documentatie: een
  // POST met `properties` overschrijft de hele set, en "it's not possible to set a line
  // item's properties property to an empty object once a value is set". Uitvinken zou
  // dus betekenen dat je de productregel weggooit en opnieuw toevoegt, waarna hij
  // onderaan de mand belandt.
  //
  // Het aantal op een verpakkingsregel is het aantal stuks dat wordt ingepakt, en dus
  // niet altijd 1. Staan er drie stuks op één productregel, dan kan de klant kiezen
  // hoeveel daarvan een verpakking krijgen, en betaalt hij per ingepakt stuk. Standaard
  // alle stuks van die regel. Besluit Sepp 31 augustus 2026; de regel die hier tot dan
  // stond (altijd 1, samen in één verpakking) had geen bron, zie docs/theme-decisions.md.
  var GIFT_HANDLE = 'cadeauverpakking';

  function initGiftWrap() {
    var messageTimer = null;
    // Alle cadeau-mutaties door één keten, zodat twee vinkjes binnen dezelfde
    // fetch-cyclus elkaar niet in de wielen rijden en er geen dubbele (onzichtbare)
    // verpakkingsregel achterblijft.
    var giftChain = Promise.resolve();
    function enqueue(task) {
      var run = giftChain.then(task, task);
      giftChain = run.then(function () {}, function () {});
      return run;
    }
    // Voert een gift-mutatie serieel uit en rendert de nieuwe cart-staat. Faalt de
    // fetch, dan wordt de mand alsnog opgehaald: het vinkje staat op dat moment in de
    // stand die de klant aanklikte en die zou anders liegen over wat er echt in ligt.
    function runGift(task) {
      enqueue(task).then(function (res) {
        if (res) handleCartMutationResponse(res);
      }).catch(function () { refreshCart(); });
    }

    function readCart() {
      return fetch('/cart.js').then(function (r) { return r.json(); });
    }

    function isGift(item) {
      return item.handle === GIFT_HANDLE;
    }

    // De verpakking hangt aan een VARIANT, niet aan een regelsleutel. Shopify
    // documenteert dat een regelsleutel verandert zodra de kenmerken van de regel
    // veranderen, "including, but not limited to, properties and discount
    // applications". Nagemeten op 31 augustus 2026: zodra een BXGY-korting aanslaat
    // splitst de regel en krijgen de helften nieuwe sleutels. De verpakking werd dan
    // een wees en opruimen() haalde hem er stil uit. Een variant-id verandert nooit.
    //
    // `_regel` wordt nog wel gelezen, zodat mandjes die op het moment van de deploy
    // openstonden niet leeg worden gegooid. Dat been mag weg na ongeveer 21 september
    // 2026.
    function hoortBij(item, doel) {
      if (!isGift(item) || !item.properties) return false;
      if (item.properties._variant !== undefined) return String(item.properties._variant) === String(doel);
      return false;
    }

    // Het aantal stuks van deze variant in de mand, over een kortingssplitsing heen.
    // Bij een lopende actie staat dezelfde variant in twee regels (7 betaald en 1
    // gratis) en hoort de klant alle acht te kunnen laten inpakken.
    function groepAantal(items, doel) {
      return items.reduce(function (som, i) {
        if (isGift(i)) return som;
        return String(i.variant_id) === String(doel) ? som + i.quantity : som;
      }, 0);
    }

    function addWrap(variantId, doel, label, aantal) {
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({
          items: [{
            id: variantId,
            quantity: aantal,
            // `Inpakken` is zichtbaar en is wat Netty op de bestelling leest,
            // `_variant` is privé (underscore) en alleen machinerie voor het thema.
            properties: { 'Inpakken': label, '_variant': String(doel) }
          }],
          sections: 'cart-drawer-contents,main-cart',
          sections_url: window.location.pathname
        })
      }).then(function (r) { return r.json(); });
    }

    // Alle verpakkingsregels die bij deze variant horen. Het zijn er meestal één,
    // maar ook een verpakkingsregel kan splitsen, dus dit geeft een lijst.
    function vindWraps(cart, doel) {
      return (cart.items || []).filter(function (i) {
        if (hoortBij(i, doel)) return true;
        // Oud been: een verpakking van voor 31 augustus 2026 wijst naar een
        // regelsleutel. Die telt mee als die regel deze variant is.
        if (!isGift(i) || !i.properties || i.properties._variant !== undefined) return false;
        var ref = i.properties._regel;
        if (!ref) return false;
        return (cart.items || []).some(function (p) {
          return !isGift(p) && p.key === ref && String(p.variant_id) === String(doel);
        });
      });
    }

    // Zet het aantal ingepakte stuks van één variant. Op 0 verdwijnen de
    // verpakkingsregels en gaat het vinkje bij de re-render vanzelf uit.
    function zetWrapAantal(doel, aantal) {
      return readCart().then(function (cart) {
        var items = cart.items || [];
        var wraps = vindWraps(cart, doel);
        if (!wraps.length) return null;
        var max = groepAantal(items, doel);
        if (aantal > max) aantal = max;
        if (aantal < 0) aantal = 0;
        var nu = wraps.reduce(function (s, w) { return s + w.quantity; }, 0);
        if (aantal === nu) return null;
        // Eerste regel op het nieuwe aantal, de rest weg. Deterministisch, en na
        // één ronde staat de som gelijk aan het gevraagde aantal.
        var updates = {};
        wraps.forEach(function (w, n) { updates[w.key] = n === 0 ? aantal : 0; });
        return updateCart(updates);
      });
    }

    function removeWrap(doel) {
      return readCart().then(function (cart) {
        var wraps = vindWraps(cart, doel);
        if (!wraps.length) return null;
        var updates = {};
        wraps.forEach(function (w) { updates[w.key] = 0; });
        return updateCart(updates);
      });
    }

    // Verwijdert de klant een product dat was aangevinkt, dan blijft zijn
    // verpakkingsregel achter en betaalt hij voor het inpakken van iets dat er niet
    // meer is. Dit ruimt die wezen op. Meteen ook een cadeauverpakking die iemand
    // rechtstreeks via /products/cadeauverpakking in zijn mand legde: die heeft geen
    // `_variant` en hoort dus bij geen enkel product.
    var opruimBezig = false;
    var opruimRondes = 0;
    function opruimen() {
      if (opruimBezig) return Promise.resolve(null);
      // Een klem kan de kortingstoekenning veranderen, dat geeft een re-render, en
      // die roept deze opruiming weer aan. De oude boolean beschermde alleen tegen
      // gelijktijdigheid, niet tegen zo'n slingering. Na drie ronden die werk blijven
      // opleveren stoppen we; een gezonde mand is na een ronde klaar.
      if (opruimRondes >= 3) return Promise.resolve(null);
      opruimBezig = true;
      function klaar(res) { opruimBezig = false; return res; }
      return readCart().then(function (cart) {
        var items = cart.items || [];

        // Twee maten naast elkaar. perVariant is de echte: die telt over een
        // kortingssplitsing heen, dus 8 en niet 7. perRegel bestaat alleen voor
        // verpakkingen van voor 31 augustus 2026, die nog naar een sleutel wijzen.
        var perVariant = {};
        var perRegel = {};
        items.forEach(function (i) {
          if (isGift(i)) return;
          var v = String(i.variant_id);
          perVariant[v] = (perVariant[v] || 0) + i.quantity;
          perRegel[i.key] = (perRegel[i.key] || 0) + i.quantity;
        });

        // Verpakkingsregels bundelen per doel. Ook een verpakkingsregel kan splitsen,
        // en wie ze los klemt, klemt ze allebei naar het maximum en dus dubbel.
        var perDoel = {};
        var wezen = [];
        items.forEach(function (i) {
          if (!isGift(i)) return;
          var props = i.properties || {};
          var doel = null;
          if (props._variant !== undefined && perVariant[String(props._variant)] !== undefined) {
            doel = 'v' + String(props._variant);
          } else if (props._variant === undefined && props._regel && perRegel[props._regel] !== undefined) {
            doel = 'k' + props._regel;
          }
          // Wees: het product is weg, of de verpakking hoort bij niets (iemand legde
          // /products/cadeauverpakking los in zijn mand).
          if (!doel) { wezen.push(i); return; }
          (perDoel[doel] = perDoel[doel] || []).push(i);
        });

        var updates = {};
        wezen.forEach(function (i) { updates[i.key] = 0; });

        Object.keys(perDoel).forEach(function (doel) {
          var max = doel.charAt(0) === 'v' ? perVariant[doel.slice(1)] : perRegel[doel.slice(1)];
          var lijnen = perDoel[doel];
          var som = lijnen.reduce(function (s, i) { return s + i.quantity; }, 0);
          if (som <= max) return;
          // Klem: er hangen meer verpakkingen aan dan er stuks van het product zijn.
          // Dat gebeurt zodra de klant drie stuks laat inpakken en daarna het aantal
          // van het product verlaagt. Zonder deze klem betaalt hij 10,50 voor het
          // inpakken van één artikel, en niemand die het merkt voor de bestelling
          // binnen is.
          lijnen.forEach(function (i, n) {
            var wordt = n === 0 ? max : 0;
            if (wordt !== i.quantity) updates[i.key] = wordt;
          });
        });

        if (!Object.keys(updates).length) { opruimRondes = 0; return null; }
        opruimRondes++;
        // In EEN aanroep, want na de eerste wijziging kunnen de overige sleutels
        // verouderd zijn.
        return updateCart(updates);
      }).then(klaar, function (err) { klaar(); throw err; });
    }
    // Bewust NIET via runGift. Die haalt de mand opnieuw op als een mutatie faalt, en
    // dat rendert opnieuw, en dat roept deze opruiming weer aan. Een blijvende fout
    // (offline, 5xx) zou dan eindeloos blijven rondgaan. Hier dus stil falen.
    giftOpruimen = function () {
      enqueue(opruimen).then(function (res) {
        if (res) handleCartMutationResponse(res);
      }).catch(function () {});
    };

    // De boodschap is order-breed en gaat als cart-attribuut de deur uit, niet als
    // property op een verpakkingsregel: die regel kan door een uitvinkactie verdwijnen
    // en dan is de tekst weg. Bewust ZONDER `sections`, want de tekst verandert geen
    // enkel bedrag en een re-render midden in het typen kost de cursor.
    function saveMessage(value) {
      return fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ attributes: { 'Boodschap': value } })
      }).then(function (r) { return r.json(); });
    }

    on(document, 'change', function (e) {
      var box = e.target.closest('[data-gift-line]');
      if (!box) return;
      // `doel` is de variant van het PRODUCT dat wordt ingepakt, `variantId` is de
      // variant van de cadeauverpakking zelf. Twee verschillende dingen, en ze
      // stonden hiervoor allebei niet in beeld omdat de koppeling op de regelsleutel
      // liep.
      var doel = box.getAttribute('data-gift-doel');
      var variantId = parseInt(box.getAttribute('data-gift-variant'), 10);
      var label = box.getAttribute('data-gift-label') || '';
      if (!doel || !variantId) return;
      // Vinkje aan betekent "deze regel inpakken", dus alle stuks van die regel. Dan
      // hoeft de klant niet te bedenken welke van de drie het cadeau wordt, en dat was
      // precies Netty's bezwaar. Wie er minder wil, zet de teller omlaag.
      var aantal = parseInt(box.getAttribute('data-gift-max'), 10) || 1;
      if (box.checked) {
        runGift(function () { return addWrap(variantId, doel, label, aantal); });
      } else {
        runGift(function () { return removeWrap(doel); });
      }
    });

    // De teller bij een regel met meer dan één stuk.
    on(document, 'click', function (e) {
      var knop = e.target.closest('[data-gift-minder], [data-gift-meer]');
      if (!knop) return;
      var meer = knop.hasAttribute('data-gift-meer');
      var doel = knop.getAttribute(meer ? 'data-gift-meer' : 'data-gift-minder');
      if (!doel) return;
      var huidig = knop.closest('[data-gift-aantal]');
      var nu = huidig ? parseInt(huidig.querySelector('.gift-aantal__waarde').textContent, 10) : 0;
      if (!nu) return;
      runGift(function () { return zetWrapAantal(doel, meer ? nu + 1 : nu - 1); });
    });

    on(document, 'input', function (e) {
      var field = e.target.closest('[data-gift-wrap-input]');
      if (!field) return;
      var waarde = field.value.trim();
      clearTimeout(messageTimer);
      messageTimer = setTimeout(function () {
        saveMessage(waarde).catch(function () {});
      }, 600);
    });

    // Eén ronde bij het laden, voor het geval de mand in een ander tabblad is
    // aangepast en er hier een wees klaarligt.
    giftOpruimen();
  }

  // Shopify weigert een mandje-wijziging met een 4xx plus een leesbare Nederlandse
  // reden in `description`: op = op, product verdwenen, limiet bereikt. Tot 27 augustus
  // 2026 werd dat antwoord gewoon als JSON doorgegeven, waarna handleCartMutationResponse
  // geen `sections` vond, de mand ververste en de klant precies niets zag. Gemeten die
  // dag: een vierde stuk van een artikel met er drie op voorraad gaf 422 met
  // "Er zijn slechts 3 artikelen aan je winkelwagen toegevoegd vanwege beschikbaarheid",
  // en het scherm bewoog niet. Een knop die niets doet leest als een kapotte winkel.
  function cartRespons(r) {
    return r.json().then(function (data) {
      if (r.ok) return data;
      var fout = new Error('Mandje-wijziging geweigerd (' + r.status + ')');
      // De status hoort op de fout mee. De aanroeper moet 422 (uitverkocht of
      // voorraadlimiet, en dus een echt antwoord van Shopify) kunnen scheiden van
      // een netwerkfout. Zonder dit vallen ze in dezelfde tak en leest de klant
      // bij een uitverkocht product niets.
      fout.status = r.status;
      fout.cartMelding = (data && (data.description || data.message)) || '';
      throw fout;
    });
  }

  // Zet de melding in de lade en op de winkelwagenpagina. Roep aan met null om hem weg
  // te halen. De lade-footer wordt niet mee-ververst, de pagina-samenvatting wel, dus
  // toon hem pas NA een verversing (zie cartMutatieFout).
  function toonCartMelding(tekst) {
    [$('.cart-drawer__footer'), $('.cart-page__summary')].forEach(function (doel) {
      if (!doel) return;
      var el = doel.querySelector('[data-cart-melding]');
      if (!tekst) { if (el) { el.hidden = true; el.textContent = ''; } return; }
      if (!el) {
        el = document.createElement('p');
        el.className = 'cart-melding';
        el.setAttribute('data-cart-melding', '');
        // role=status en niet alert: dit is informatie ("er zijn er nog drie"), geen
        // fout van de klant, en alert onderbreekt een schermlezer midden in een zin.
        el.setAttribute('role', 'status');
        doel.insertBefore(el, doel.firstChild);
      }
      el.hidden = false;
      el.textContent = tekst;
    });
  }

  function cartMutatieFout(err) {
    var tekst = (err && err.cartMelding) || 'Dit lukte niet. Ververs de pagina en probeer het nog eens.';
    // Eerst terug naar de echte stand, dan pas melden. Andersom wist de verversing de
    // melding meteen weer weg, want de samenvatting op de pagina wordt vervangen.
    return refreshCart().then(function () { toonCartMelding(tekst); });
  }

  function addToCart(variantId, quantity) {
    cartMetaToken++;
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        items: [{ id: variantId, quantity: quantity }],
        sections: 'cart-drawer-contents,main-cart',
        sections_url: window.location.pathname
      })
    }).then(cartRespons);
  }

  function changeCart(key, quantity) {
    cartMetaToken++;
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        id: key,
        quantity: quantity,
        sections: 'cart-drawer-contents,main-cart',
        sections_url: window.location.pathname
      })
    }).then(cartRespons);
  }

  // Meerdere regels in EEN aanroep, op regelsleutel. Nodig zodra een groep uit meer
  // dan een regel bestaat: wie ze een voor een op 0 zet, verandert met de eerste
  // aanroep de kortingstoekenning en daarmee de sleutel van de tweede.
  //
  // Bewust op sleutels en niet op variant-id. De documentatie is daar expliciet over:
  // "if the variant_id matches multiple line items, then the first matching line item
  // is updated". Bij een gesplitste regel zou dat de gratis helft laten staan. Op
  // sleutels nagemeten op 31 augustus 2026: drie regels in een keer weg.
  function updateCart(updates) {
    cartMetaToken++;
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        updates: updates,
        sections: 'cart-drawer-contents,main-cart',
        sections_url: window.location.pathname
      })
    }).then(cartRespons);
  }

  // Het kaartje-bericht komt server-side uit cart.attributes, maar die is pas gevuld
  // nadat de debounce van 600 ms is afgelopen. Een innerHTML-swap tijdens het typen zou
  // dus wissen wat er net is ingetikt, plus de focus. Snapshot de waarde en de cursor,
  // swap, en zet ze terug. Per-container zodat drawer en cart-page elkaar niet kruisen.
  function swapPreservingGift(container, newHTML) {
    var active = document.activeElement;
    var input = container.querySelector('[data-gift-wrap-input]');
    var hadFocus = input === active;
    var snapVal = input ? input.value : null;
    var selStart = null, selEnd = null;
    if (hadFocus) { try { selStart = input.selectionStart; selEnd = input.selectionEnd; } catch (e) {} }
    container.innerHTML = newHTML;
    var newInput = container.querySelector('[data-gift-wrap-input]');
    if (newInput && snapVal !== null) {
      // Het bericht komt server-side als property terug. Had de klant focus of is
      // het verse veld leeg, dan wint wat net getypt is.
      if (snapVal && (hadFocus || !newInput.value)) newInput.value = snapVal;
      if (hadFocus) {
        newInput.focus();
        if (selStart != null) { try { newInput.setSelectionRange(selStart, selEnd); } catch (e) {} }
      }
    }
  }

  function updateCartFromSections(cartResponse) {
    // Een geslaagde verversing is het bewijs dat de vorige melding niet meer geldt,
    // dus die gaat hier weg. Dit moet expliciet: op de winkelwagenpagina zit de
    // melding binnen het geswapte .cart-page__inner en verdwijnt hij vanzelf, maar in
    // de lade staat .cart-drawer__footer buiten [data-cart-drawer-body] en bleef hij
    // anders staan tot een pagina-herlading, ook nadat de klant het had opgelost.
    // cartMutatieFout zet zijn melding pas ná refreshCart, dus die overleeft dit.
    toonCartMelding(null);

    var sections = cartResponse.sections || {};
    if (sections['cart-drawer-contents']) {
      var body = $('[data-cart-drawer-body]');
      if (body) {
        var doc = new DOMParser().parseFromString(sections['cart-drawer-contents'], 'text/html');
        // De marker bewijst alleen dat de sectie echt cart-inhoud teruggaf; wat er
        // wordt omgewisseld is alles binnen de shopify-section-wrapper. Hiervoor stond
        // hier inner.parentElement, en dat is precies een stap omhoog vanaf de lijst.
        // Dat werkt alleen zolang de balk, de lijst en de totalen broers zijn. Zet je
        // er in het thema één div omheen, dan wijst parentElement naar die div en
        // vallen de balk en de totalen stil uit de lade, zonder foutmelding.
        var marker = doc.querySelector('[data-cart-items]') || doc.querySelector('.cart-drawer__empty');
        var wortel = doc.querySelector('.shopify-section') || doc.body;
        if (marker) {
          swapPreservingGift(body, wortel.innerHTML);
        }
      }
    }
    if (sections['main-cart']) {
      var cartPageInner = document.querySelector('.cart-page__inner');
      if (cartPageInner) {
        var pageDoc = new DOMParser().parseFromString(sections['main-cart'], 'text/html');
        var newInner = pageDoc.querySelector('.cart-page__inner');
        if (newInner) swapPreservingGift(cartPageInner, newInner.innerHTML);
      }
    }
    applyCartMeta(cartResponse);
    // Een verwijderd product laat zijn verpakkingsregel achter. Die hoort hier weg,
    // en niet pas bij het afrekenen als de klant het al betaald heeft.
    if (giftOpruimen) giftOpruimen();
  }

  // Schrijft teller, totaal en checkout-status alleen als de respons echte
  // cart-meta bevat. /cart/add.js geeft die niet terug, dus daar mag dit niet
  // met undefined draaien (anders "undefined" in de badge en "EUR NaN" als totaal).
  function applyCartMeta(cart) {
    if (typeof cart.item_count !== 'number') return;
    $$('[data-cart-count]').forEach(function (countEl) {
      var vorig = parseInt(countEl.textContent, 10) || 0;
      countEl.textContent = cart.item_count;
      countEl.classList.toggle('is-empty', cart.item_count === 0);
      // Korte pop op de header-badge zodat een toevoeging ook bovenin landt.
      // Test op het data-attribuut, niet op de CSS-klasse: een hernoeming in de
      // stylesheet zou de animatie anders stil uitzetten zonder dat iets faalt.
      if (cart.item_count > vorig && countEl.hasAttribute('data-count-pop')) {
        countEl.classList.remove('is-bumped');
        void countEl.offsetWidth; // reflow forceren zodat de animatie opnieuw start
        countEl.classList.add('is-bumped');
      }
    });
    // Het totaal komt uit de server-gerenderde sectie (money-filter), niet uit JS.
    // Beide [data-cart-total] zitten in geswapte secties, dus een JS-write zou het
    // alleen overschrijven met een afwijkende notatie. Hier alleen teller + checkout.
    var checkoutLink = $('[data-cart-checkout]');
    if (checkoutLink) checkoutLink.classList.toggle('is-disabled', cart.item_count === 0);
  }

  // Volgnummer dat bij elke cart-mutatie oploopt. Een trage /cart.js die pas ná een
  // nieuwere mutatie terugkomt, mag de teller niet met een verouderde waarde overschrijven.
  var cartMetaToken = 0;
  // Wordt door initGiftWrap gevuld. Staat op moduleniveau zodat updateCartFromSections
  // erbij kan zonder dat de cadeau-logica daarheen hoeft te verhuizen.
  var giftOpruimen = null;

  // Haalt de echte cart-meta op na een add. De add-respons bevat alleen de
  // toegevoegde regels, dus de teller komt hiervandaan.
  function updateCartMeta() {
    var token = cartMetaToken;
    return fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) { if (token === cartMetaToken) applyCartMeta(cart); return cart; })
      .catch(function (err) { console.warn('updateCartMeta faalde', err); });
  }

  function refreshCart() {
    return fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        return fetch('/?sections=cart-drawer-contents,main-cart')
          .then(function (r) { return r.json(); })
          .then(function (data) {
            cart.sections = data;
            updateCartFromSections(cart);
            return cart;
          });
      })
      .catch(function (err) {
        console.warn('refreshCart fetch failed', err);
      });
  }

  /* Intercept ATC-formulieren (productpagina) zodat ze in de cart-drawer
     belanden in plaats van een page-reload naar /cart. */
  function initProductFormSubmit() {
    on(document, 'submit', function (e) {
      var form = e.target.closest('form[action*="/cart/add"]');
      if (!form) return;
      e.preventDefault();
      var submitBtn = form.querySelector('[data-product-add], button[name="add"]');
      var originalHTML = submitBtn ? submitBtn.innerHTML : null;
      if (submitBtn) {
        if (submitBtn.disabled) return;
        submitBtn.disabled = true;
        submitBtn.classList.add('is-loading');
        submitBtn.dataset.previousHtml = originalHTML;
      }
      cartMetaToken++;
      var formToken = cartMetaToken;
      var formData = new FormData(form);
      formData.append('sections', 'cart-drawer-contents,main-cart');
      formData.append('sections_url', window.location.pathname);
      fetch('/cart/add.js', { method: 'POST', body: formData })
        .then(cartRespons)
        .then(function (response) {
          if (response && response.sections) {
            if (formToken === cartMetaToken) updateCartFromSections(response);
            updateCartMeta();
          } else {
            refreshCart();
          }
          var drawer = document.querySelector('[data-cart-drawer]');
          if (drawer) {
            drawer.classList.add('is-open');
            drawer.setAttribute('aria-hidden', 'false');
            document.body.classList.add('has-drawer-open');
          }
          if (submitBtn) {
            submitBtn.classList.remove('is-loading');
            submitBtn.classList.add('is-added');
            setTimeout(function () {
              submitBtn.disabled = false;
              submitBtn.classList.remove('is-added');
              submitBtn.innerHTML = originalHTML;
            }, 1500);
          }
        })
        .catch(function (err) {
          if (submitBtn) submitBtn.classList.remove('is-loading');
          // Zelfde route als quick-add: dit formulier liep hiervoor langs cartRespons
          // heen met een eigen r.json(), en dat waren twee manieren om dezelfde fout
          // af te handelen. Nu een.
          if (err && err.status === 422) {
            console.error('Add to cart afgewezen:', err.cartMelding);
            if (submitBtn) {
              submitBtn.innerHTML = 'Niet op voorraad';
              setTimeout(function () {
                submitBtn.disabled = false;
                submitBtn.innerHTML = originalHTML;
              }, 1800);
            }
            return;
          }
          console.error('Add to cart fout', err);
          if (submitBtn) {
            submitBtn.disabled = false;
            submitBtn.innerHTML = originalHTML;
          }
        });
    });
  }

  function formatMoney(cents) {
    var euros = (cents / 100).toFixed(2).replace('.', ',');
    return '€' + euros;
  }

  /* --------- Newsletter --------- */
  function initNewsletter() {
    var forms = $$('[data-newsletter-form]');
    if (forms.length === 0) return;

    // Echte succes-status: Shopify redirect na een geslaagde inschrijving
    // terug met ?customer_posted=true. Pas dan succes tonen, niet eerder;
    // de oude variant toonde succes al vóór de server iets had verwerkt.
    var posted = /[?&]customer_posted=true/.test(window.location.search);

    forms.forEach(function (form) {
      if (posted) {
        var success = form.parentElement.querySelector('[data-newsletter-success]') || $('[data-newsletter-success]', form.closest('section') || document);
        var intro = form.parentElement.querySelector('[data-newsletter-intro]');
        if (success) success.hidden = false;
        if (intro) intro.hidden = true;
        form.hidden = true;
        return;
      }
      on(form, 'submit', function (e) {
        // Alleen client-side blokkeren bij een evident ongeldig adres;
        // de submit zelf gaat naar Shopify en komt terug met customer_posted.
        var input = form.querySelector('input[name="contact[email]"]');
        var email = input ? input.value.trim() : '';
        if (!email || email.indexOf('@') === -1 || email.indexOf('.') === -1) {
          e.preventDefault();
          if (input) {
            input.setAttribute('aria-invalid', 'true');
            input.focus();
          }
        }
      });
    });
  }

  /* --------- Quiz (huid + haar, tag-gestuurde top-3) --------- */
  function initQuiz() {
    var root = $('[data-quiz-root]');
    if (!root) return;

    // Mode-toggle tussen huid- en haarquiz.
    var modeBtns = $$('[data-quiz-mode-btn]', root);
    var panels = $$('[data-quiz-panel]', root);
    function activateMode(mode) {
      panels.forEach(function (p) {
        var active = p.getAttribute('data-quiz-panel') === mode;
        p.classList.toggle('is-active', active);
        if (active) { p.removeAttribute('hidden'); } else { p.setAttribute('hidden', ''); }
      });
      modeBtns.forEach(function (b) {
        var active = b.getAttribute('data-quiz-mode-btn') === mode;
        b.classList.toggle('is-active', active);
        b.setAttribute('aria-selected', active ? 'true' : 'false');
        // Roving tabindex: alleen de actieve tab in de tab-volgorde (WAI-ARIA tab-pattern).
        b.setAttribute('tabindex', active ? '0' : '-1');
      });
    }
    modeBtns.forEach(function (b, i) {
      on(b, 'click', function () { activateMode(b.getAttribute('data-quiz-mode-btn')); });
      // Pijltjes-navigatie tussen de tabs, met Home/End, conform het tab-pattern.
      on(b, 'keydown', function (e) {
        var idx = -1;
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') { idx = (i + 1) % modeBtns.length; }
        else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') { idx = (i - 1 + modeBtns.length) % modeBtns.length; }
        else if (e.key === 'Home') { idx = 0; }
        else if (e.key === 'End') { idx = modeBtns.length - 1; }
        else { return; }
        e.preventDefault();
        var target = modeBtns[idx];
        activateMode(target.getAttribute('data-quiz-mode-btn'));
        target.focus();
      });
    });

    // Start op de ingestelde standaard-modus zodat het zichtbare panel en de
    // actieve toggle-knop synchroon lopen, ook als default_mode 'haar' is.
    activateMode(root.getAttribute('data-default-mode') || 'huid');

    panels.forEach(initQuizPanel);
  }

  function initQuizPanel(panel) {
    var steps = $$('[data-quiz-step]', panel);
    var stepLabel = $('[data-quiz-step-label]', panel);
    var progressFill = $('[data-quiz-progress-fill]', panel);
    var resultIntroEl = $('[data-quiz-result-intro]', panel);
    var resultGrid = $('[data-quiz-result-grid]', panel);
    var restartBtn = $('[data-quiz-restart]', panel);
    var questionsPanel = $('.skin-quiz__panel', panel);
    var totalSteps = 3;
    var noun = panel.getAttribute('data-quiz-panel') === 'haar' ? 'haar' : 'huid';

    var state = { type: null, typeTag: null, goal: null, goalTag: null, goalTag2: null };

    // Kandidaat-pool inlezen uit de server-side gerenderde producten.
    var pool = $$('[data-quiz-product]', panel).map(function (el) {
      return {
        title: el.getAttribute('data-title') || '',
        url: el.getAttribute('data-url') || '',
        image: el.getAttribute('data-image') || '',
        price: el.getAttribute('data-price') || '',
        tags: (el.getAttribute('data-tags') || '').split(/\s+/).filter(Boolean)
      };
    });

    function showStep(stepNum) {
      steps.forEach(function (step) {
        step.classList.toggle('is-active', parseInt(step.getAttribute('data-quiz-step'), 10) === stepNum);
      });
      // Stap 3 (extra wens): verberg de optie die gelijk is aan het gekozen
      // hoofddoel uit stap 2, anders ziet de bezoeker dezelfde keuze twee keer.
      if (stepNum === 3 && state.goalTag) {
        $$('[data-quiz-goal2-tag]', panel).forEach(function (btn) {
          var t = btn.getAttribute('data-quiz-goal2-tag');
          btn.style.display = (t && t === state.goalTag) ? 'none' : '';
        });
      }
      // Vragenpanel (met voortgangsbalk) verbergen op de resultaatstap, zodat
      // alleen het donkere resultaatblok zichtbaar is.
      if (questionsPanel) questionsPanel.style.display = stepNum > totalSteps ? 'none' : '';
      if (stepNum <= totalSteps && stepLabel) {
        stepLabel.textContent = 'Stap ' + stepNum + ' van ' + totalSteps;
      }
      if (progressFill) {
        var pct = stepNum > totalSteps ? 100 : (stepNum / totalSteps) * 100;
        progressFill.style.width = pct + '%';
      }
    }

    panel.addEventListener('click', function (e) {
      var optionBtn = e.target.closest('[data-quiz-answer]');
      if (!optionBtn || !panel.contains(optionBtn)) return;

      var answer = optionBtn.getAttribute('data-quiz-answer');
      var parts = answer.split(':');
      var key = parts[0];
      state[key] = parts.slice(1).join(':');

      if (key === 'type') {
        state.typeTag = optionBtn.getAttribute('data-quiz-type-tag') || null;
      } else if (key === 'goal') {
        state.goalTag = optionBtn.getAttribute('data-quiz-goal-tag') || null;
      } else if (key === 'goal2') {
        state.goalTag2 = optionBtn.getAttribute('data-quiz-goal2-tag') || null;
      }

      var currentStep = parseInt(optionBtn.closest('[data-quiz-step]').getAttribute('data-quiz-step'), 10);
      if (currentStep < totalSteps) {
        setTimeout(function () { showStep(currentStep + 1); }, 250);
      } else {
        showResult();
      }
    });

    if (restartBtn) {
      on(restartBtn, 'click', function () {
        state = { type: null, typeTag: null, goal: null, goalTag: null, goalTag2: null };
        if (resultGrid) resultGrid.innerHTML = '';
        showStep(1);
      });
    }

    // Scoor de pool op doel (zwaarst) en type, geef alleen de echte matches
    // terug (top N). Bewust geen opvulling met niet-matchende producten: op een
    // "dit past bij jou"-scherm horen geen producten die nergens op matchen.
    // Minder dan drie matches is eerlijker dan drie met vulling.
    function rankProducts(limit) {
      return pool
        .map(function (p) {
          var score = 0;
          if (state.goalTag && p.tags.indexOf(state.goalTag) !== -1) score += 3;
          if (state.typeTag && p.tags.indexOf(state.typeTag) !== -1) score += 2;
          if (state.goalTag2 && p.tags.indexOf(state.goalTag2) !== -1) score += 1;
          return { p: p, score: score };
        })
        .filter(function (s) { return s.score > 0; })
        .sort(function (a, b) { return b.score - a.score; })
        .slice(0, limit)
        .map(function (s) { return s.p; });
    }

    // Kaart via DOM-API bouwen, niet via innerHTML-string: de producttitel en
    // url komen uit productdata en mogen niet als HTML geinterpreteerd worden.
    function buildCard(p, viewLabel) {
      var card = document.createElement('a');
      card.className = 'skin-quiz__card';
      card.setAttribute('href', p.url);

      if (p.image) {
        var img = document.createElement('img');
        img.className = 'skin-quiz__card-img';
        img.setAttribute('src', p.image);
        img.setAttribute('alt', p.title);
        img.setAttribute('loading', 'lazy');
        img.setAttribute('width', '320');
        img.setAttribute('height', '320');
        card.appendChild(img);
      }

      var body = document.createElement('div');
      body.className = 'skin-quiz__card-body';

      var name = document.createElement('h4');
      name.className = 'skin-quiz__card-name';
      name.textContent = p.title;
      body.appendChild(name);

      if (p.price) {
        var price = document.createElement('p');
        price.className = 'skin-quiz__card-price';
        price.textContent = p.price;
        body.appendChild(price);
      }

      var cta = document.createElement('span');
      cta.className = 'skin-quiz__card-cta';
      cta.textContent = viewLabel;
      body.appendChild(cta);

      card.appendChild(body);
      return card;
    }

    function showResult() {
      if (resultIntroEl && state.type && state.goal) {
        var tpl = panel.getAttribute('data-quiz-result-template');
        if (tpl) {
          // replace is een no-op als een placeholder ontbreekt, dus partial
          // templates blijven gewoon werken.
          resultIntroEl.textContent = tpl
            .replace('{type}', state.type.toLowerCase())
            .replace('{goal}', state.goal.toLowerCase());
        } else {
          resultIntroEl.textContent =
            'Matches voor ' + state.type.toLowerCase() + ' ' + noun +
            ' met focus op ' + state.goal.toLowerCase() + '.';
        }
      }

      if (resultGrid) {
        var viewLabel = resultGrid.getAttribute('data-quiz-view-label') || 'Bekijk product';
        var top = rankProducts(3);
        resultGrid.innerHTML = '';
        if (top.length) {
          top.forEach(function (p) { resultGrid.appendChild(buildCard(p, viewLabel)); });
        } else {
          var empty = document.createElement('p');
          empty.className = 'skin-quiz__result-empty';
          empty.textContent = resultGrid.getAttribute('data-quiz-empty-label') ||
            'Geen directe match gevonden. Stuur een berichtje via WhatsApp voor persoonlijk advies.';
          resultGrid.appendChild(empty);
        }
      }

      showStep(4);
    }
  }

  /* --------- Ingredients lab --------- */
  function initIngredientsLab() {
    var lab = $('[data-ingredients-lab]');
    if (!lab) return;
    var cards = $$('[data-ingredient-card]', lab);

    cards.forEach(function (card) {
      on(card, 'mouseenter', function () { setActive(card); });
      on(card, 'click', function () { setActive(card); });
      on(card, 'focus', function () { setActive(card); });
    });

    function setActive(activeCard) {
      cards.forEach(function (c) { c.classList.toggle('is-active', c === activeCard); });
    }
  }

  /* --------- Collection sort --------- */
  function initCollectionSort() {
    var sortSelect = $('[data-sort-select]');
    if (!sortSelect) return;
    on(sortSelect, 'change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortSelect.value);
      window.location.href = url.toString();
    });
  }

  /* --------- Collection filter drawer --------- */
  function initFilterDrawer() {
    var drawer = $('[data-filter-drawer]');
    if (!drawer) return;
    var toggles = $$('[data-filter-toggle]');
    var closes = $$('[data-filter-close]', drawer);
    if (toggles.length === 0) return;

    function open() {
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      toggles.forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
      lockBody('is-filter-drawer-open');
      var firstLink = $('.filter-drawer__link', drawer);
      if (firstLink) requestAnimationFrame(function () { firstLink.focus(); });
    }
    function close() {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      toggles.forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
      unlockBody('is-filter-drawer-open');
    }

    toggles.forEach(function (b) { on(b, 'click', open); });
    closes.forEach(function (b) { on(b, 'click', close); });
    on(document, 'keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) close();
    });
    on(drawer, 'keydown', function (e) {
      if (e.key === 'Tab') trapFocus(drawer, e);
    });
  }

  /* --------- Collection load more --------- */
  function initCollectionLoadMore() {
    var section = $('[data-collection-section]');
    if (!section) return;
    var grid = $('[data-collection-grid]', section);
    var button = $('[data-collection-load-more]', section);
    var loadedCounter = $('[data-loaded-count]', section);
    var endNote = $('[data-collection-end]', section);

    var initialCount = $$('.product-card', section).length;
    if (loadedCounter) loadedCounter.textContent = initialCount;
    if (!button || !grid) return;

    var loading = false;
    var originalLabel = button.textContent.trim();

    on(button, 'click', function () {
      if (loading) return;
      var nextUrl = button.getAttribute('data-next-url');
      if (!nextUrl) return;

      loading = true;
      button.disabled = true;
      button.textContent = 'Laden...';

      fetch(nextUrl, { credentials: 'same-origin' })
        .then(function (resp) {
          if (!resp.ok) throw new Error('Request failed');
          return resp.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var newGrid = doc.querySelector('[data-collection-grid]');
          var newButton = doc.querySelector('[data-collection-load-more]');

          if (newGrid) {
            Array.prototype.slice.call(newGrid.children).forEach(function (card) {
              grid.appendChild(card);
            });
          }

          if (loadedCounter) {
            loadedCounter.textContent = $$('.product-card', section).length;
          }

          if (newButton && newButton.getAttribute('data-next-url')) {
            button.setAttribute('data-next-url', newButton.getAttribute('data-next-url'));
            button.disabled = false;
            button.textContent = originalLabel;
          } else {
            button.parentElement.removeChild(button);
            if (endNote) endNote.hidden = false;
          }

          loading = false;
        })
        .catch(function () {
          button.disabled = false;
          button.textContent = originalLabel;
          loading = false;
        });
    });
  }

  /* --------- Product page quantity --------- */
  function initProductQty() {
    var input = $('[data-qty-input]');
    if (!input) return;
    on($('[data-qty-increment]'), 'click', function () {
      input.value = parseInt(input.value, 10) + 1;
    });
    on($('[data-qty-decrement]'), 'click', function () {
      input.value = Math.max(1, parseInt(input.value, 10) - 1);
    });
  }

  /* --------- Mega menu --------- */
  function initMegaMenu() {
    var nav = $('[data-mega-nav]');
    if (!nav) return;

    var items = $$('[data-mega-item]', nav);
    var openItem = null;
    var closeTimer = null;

    function openMega(item) {
      if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
      if (openItem && openItem !== item) {
        openItem.classList.remove('is-open');
        var trigger = openItem.querySelector('[data-mega-trigger]');
        if (trigger) trigger.setAttribute('aria-expanded', 'false');
      }
      item.classList.add('is-open');
      var trigger = item.querySelector('[data-mega-trigger]');
      if (trigger) trigger.setAttribute('aria-expanded', 'true');
      openItem = item;
    }

    function closeMega(item, immediate) {
      var doClose = function () {
        item.classList.remove('is-open');
        var trigger = item.querySelector('[data-mega-trigger]');
        if (trigger) trigger.setAttribute('aria-expanded', 'false');
        if (openItem === item) openItem = null;
      };
      if (immediate) doClose();
      else closeTimer = setTimeout(doClose, 150);
    }

    items.forEach(function (item) {
      if (!item.classList.contains('has-mega')) return;
      var trigger = item.querySelector('[data-mega-trigger]');
      var panel = item.querySelector('[data-mega-panel]');
      if (!trigger || !panel) return;

      on(item, 'mouseenter', function () { openMega(item); });
      on(item, 'mouseleave', function () { closeMega(item); });
      on(trigger, 'focus', function () { openMega(item); });
      on(trigger, 'click', function (e) {
        // Op desktop met hover: klik laat de browser doorlinken naar de pagina.
        // Op touch: blokkeer eerste klik en open in plaats daarvan het paneel.
        if (window.matchMedia('(hover: none)').matches && !item.classList.contains('is-open')) {
          e.preventDefault();
          openMega(item);
        }
      });
      panel.addEventListener('mouseenter', function () {
        if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
      });
      // Focus-trap: sluit menu zodra focus het item verlaat (Tab eruit).
      item.addEventListener('focusout', function (e) {
        if (!item.contains(e.relatedTarget)) closeMega(item, true);
      });
    });

    on(document, 'keydown', function (e) {
      if (e.key === 'Escape' && openItem) {
        var trigger = openItem.querySelector('[data-mega-trigger]');
        closeMega(openItem, true);
        if (trigger) trigger.focus();
      }
    });
    on(document, 'click', function (e) {
      if (openItem && !openItem.contains(e.target)) closeMega(openItem, true);
    });
  }

  /* --------- Bestseller carousel --------- */
  function initBestsellerCarousel() {
    $$('[data-bestseller-track]').forEach(function (track) {
      var section = track.closest('section');
      if (!section) return;
      var prev = section.querySelector('[data-bestseller-prev]');
      var next = section.querySelector('[data-bestseller-next]');
      if (!prev || !next) return;

      function scrollBy(direction) {
        var item = track.querySelector('.bestseller-carousel__item');
        var step = item ? item.offsetWidth + 24 : 280;
        track.scrollBy({ left: direction * step * 2, behavior: 'smooth' });
      }
      on(prev, 'click', function () { scrollBy(-1); });
      on(next, 'click', function () { scrollBy(1); });
    });
  }

  /* --------- Reviews auto-scroll marquee --------- */
  // Reviews scrollen rustig door van links naar rechts, pauzeren bij hover of
  // focus, en zijn met de pijltjes handmatig te bedienen. Een verborgen duplicaat
  // van de kaarten maakt de loop naadloos.
  function initReviewMarquee() {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    $$('[data-review-carousel]').forEach(function (root) {
      var track = root.querySelector('[data-review-marquee]');
      if (!track) return;
      var prev = root.querySelector('[data-review-prev]');
      var next = root.querySelector('[data-review-next]');
      var pauseHover = false;
      var offscreen = false;
      var manualUntil = 0;
      // Positie in een eigen variabele bijhouden, niet uit scrollLeft teruglezen:
      // Blink rondt scrollLeft op dpr=1 af naar hele pixels, dus += 0.4 zou daar
      // nooit de 1 kruisen en de marquee zou stilstaan.
      var pos = track.scrollLeft;
      var running = false;

      function cardStep() {
        var card = track.querySelector('.testimonial');
        var gap = parseFloat(getComputedStyle(track).gap) || 24;
        return card ? card.getBoundingClientRect().width + gap : track.clientWidth * 0.8;
      }
      function wrap(x) {
        var half = track.scrollWidth / 2;
        if (half <= 0) return x;
        if (x >= half) return x - half;
        if (x < 0) return x + half;
        return x;
      }
      function manual() { manualUntil = Date.now() + 4000; }

      if (prev) on(prev, 'click', function () { manual(); track.scrollBy({ left: -cardStep(), behavior: 'smooth' }); });
      if (next) on(next, 'click', function () { manual(); track.scrollBy({ left: cardStep(), behavior: 'smooth' }); });
      on(root, 'mouseenter', function () { pauseHover = true; });
      on(root, 'mouseleave', function () { pauseHover = false; });
      on(root, 'focusin', function () { pauseHover = true; });
      on(root, 'focusout', function () { pauseHover = false; });
      // Mobiel: bij aanraking pauzeren zodat een veeg niet vecht met de auto-scroll.
      on(track, 'touchstart', function () { manual(); });
      on(track, 'pointerdown', function () { manual(); });
      // Buiten beeld niet doorrekenen.
      if (window.IntersectionObserver) {
        new IntersectionObserver(function (entries) { offscreen = !entries[0].isIntersecting; }).observe(root);
      }

      if (reduce) return; // geen auto-scroll als de bezoeker minder beweging wil
      function tick() {
        if (!pauseHover && !offscreen && Date.now() > manualUntil) {
          if (!running) { pos = track.scrollLeft; running = true; } // hersync na pauze of handmatig scrollen
          pos = wrap(pos + 0.4); // rustige snelheid
          track.scrollLeft = pos;
        } else {
          running = false;
        }
        requestAnimationFrame(tick);
      }
      requestAnimationFrame(tick);
    });
  }

  /* --------- Product page thumbnails --------- */
  function initProductThumbnails() {
    var section = $('[data-product-section]');
    if (!section) return;
    var mainImg = section.querySelector('[data-product-main-image]');
    if (!mainImg) return;

    $$('[data-product-thumbnail]', section).forEach(function (btn) {
      on(btn, 'click', function () {
        var src = btn.getAttribute('data-thumbnail-src');
        if (!src) return;
        // Verwijder srcset zodat de browser de nieuwe src ook werkelijk gebruikt
        mainImg.removeAttribute('srcset');
        mainImg.removeAttribute('sizes');
        mainImg.src = src;
        $$('[data-product-thumbnail]', section).forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');

        // Two-way sync: hoort deze foto bij een variant, selecteer die dan ook.
        // Guard op radio.checked voorkomt een lus met de variant-handler.
        var mediaId = btn.getAttribute('data-media-id');
        if (mediaId) {
          var radio = section.querySelector('[data-product-variant-radio][data-variant-media-id="' + mediaId + '"]');
          if (radio && !radio.checked && !radio.disabled) {
            radio.checked = true;
            radio.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
      });
    });
  }

  /* --------- Product page variant pills --------- */
  function initProductVariantPills() {
    var section = $('[data-product-section]');
    if (!section) return;
    var radios = $$('[data-product-variant-radio]', section);
    if (radios.length === 0) return;

    var variants = [];
    try { variants = JSON.parse(section.getAttribute('data-product-variants') || '[]'); }
    catch (e) { variants = []; }

    var priceEl = section.querySelector('[data-product-price]');
    var priceCompareEl = section.querySelector('[data-product-price-compare]');
    var addBtn = section.querySelector('[data-product-add]');

    function findVariant(id) {
      for (var i = 0; i < variants.length; i++) {
        if (String(variants[i].id) === String(id)) return variants[i];
      }
      return null;
    }

    radios.forEach(function (radio) {
      on(radio, 'change', function () {
        $$('.product-hero__variant-pill', section).forEach(function (pill) {
          pill.classList.remove('is-active');
        });
        radio.closest('.product-hero__variant-pill').classList.add('is-active');

        var variant = findVariant(radio.value);
        if (!variant) return;

        if (priceEl) priceEl.textContent = formatMoney(variant.price);
        if (priceCompareEl) {
          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            priceCompareEl.textContent = formatMoney(variant.compare_at_price);
            priceCompareEl.removeAttribute('hidden');
            priceEl.classList.add('product-hero__price--sale');
          } else {
            priceCompareEl.setAttribute('hidden', '');
            priceCompareEl.textContent = '';
            priceEl.classList.remove('product-hero__price--sale');
          }
        }
        if (addBtn) {
          // Alleen de label-span bijwerken: textContent op de hele knop zou
          // ook de meta-regel ("14 dagen bedenktijd") en het icoon wissen.
          var labelEl = addBtn.querySelector('span');
          var metaEl = addBtn.querySelector('.product-hero__add-meta');
          function setLabel(text) {
            if (labelEl && labelEl !== metaEl) labelEl.textContent = text;
            else addBtn.textContent = text;
          }
          if (variant.available) {
            addBtn.disabled = false;
            setLabel(addBtn.getAttribute('data-label-available') || 'Voeg toe');
            if (metaEl) metaEl.hidden = false;
          } else {
            addBtn.disabled = true;
            setLabel(addBtn.getAttribute('data-label-unavailable') || 'Tijdelijk uitverkocht');
            if (metaEl) metaEl.hidden = true;
          }
        }

        // Two-way sync: toon de foto van de gekozen variant in de galerij.
        // thumb.click() hergebruikt de thumbnail-handler; die slaat de
        // variant-selectie over omdat de radio al checked is (geen lus).
        var mediaId = radio.getAttribute('data-variant-media-id');
        if (mediaId) {
          var thumb = section.querySelector('[data-product-thumbnail][data-media-id="' + mediaId + '"]');
          if (thumb && !thumb.classList.contains('is-active')) thumb.click();
        }
      });
    });
  }

  /* --------- Recently viewed --------- */
  var RECENT_KEY = 'bylanette_recent_products';
  var RECENT_MAX = 8;

  function trackRecentlyViewed() {
    var section = $('[data-product-section]');
    if (!section) return;
    var handle = section.getAttribute('data-product-handle');
    if (!handle) return;
    try {
      var stored = JSON.parse(localStorage.getItem(RECENT_KEY) || '[]');
      stored = stored.filter(function (h) { return h !== handle; });
      stored.unshift(handle);
      stored = stored.slice(0, RECENT_MAX);
      localStorage.setItem(RECENT_KEY, JSON.stringify(stored));
    } catch (e) { /* localStorage unavailable */ }
  }

  function renderRecentlyViewed() {
    var container = $('[data-recently-viewed]');
    if (!container) return;
    var grid = container.querySelector('[data-recently-viewed-grid]');
    if (!grid) return;

    var stored;
    try { stored = JSON.parse(localStorage.getItem(RECENT_KEY) || '[]'); }
    catch (e) { stored = []; }

    var currentHandle = '';
    var productSection = $('[data-product-section]');
    if (productSection) currentHandle = productSection.getAttribute('data-product-handle');
    var handles = stored.filter(function (h) { return h !== currentHandle; }).slice(0, 4);

    if (handles.length === 0) return;

    Promise.all(handles.map(function (h) {
      return fetch('/products/' + encodeURIComponent(h) + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    })).then(function (products) {
      var html = products.filter(Boolean).map(function (p) {
        var img = p.featured_image || (p.images && p.images[0]) || '';
        var safeUrl = escapeHtml(p.url);
        var safeImg = escapeHtml(img);
        return '' +
          '<article class="product-card">' +
            '<a href="' + safeUrl + '" class="product-card__media-link">' +
              '<div class="product-card__media">' +
                (img ? '<img src="' + safeImg + '" alt="' + escapeHtml(p.title) + '" loading="lazy" class="product-card__image">' : '') +
              '</div>' +
            '</a>' +
            '<div class="product-card__info">' +
              (p.type ? '<span class="product-card__type">' + escapeHtml(p.type) + '</span>' : '') +
              '<a href="' + safeUrl + '" class="product-card__name">' + escapeHtml(p.title) + '</a>' +
              '<p class="product-card__price">' + formatMoney(p.price) + '</p>' +
            '</div>' +
          '</article>';
      }).join('');
      if (html) {
        grid.innerHTML = html;
        container.hidden = false;
      }
    });
  }

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* --------- Header zoekpaneel ---------
     Was het account-plus-winkelmandpaneel; sinds 21 juli 2026 heeft elk icoon
     een eigen klik en bevat dit paneel alleen nog het zoekveld. */
  function initUtilityDropdown() {
    var panel = $('[data-utility-panel]');
    var searchToggle = $('[data-search-toggle]');
    if (!panel || !searchToggle) return;

    var searchInput = panel.querySelector('input[type="search"]');
    var triggers = [searchToggle];

    function setExpanded(state) {
      triggers.forEach(function (t) { t.setAttribute('aria-expanded', state ? 'true' : 'false'); });
    }
    function open(focusSearch) {
      panel.hidden = false;
      setExpanded(true);
      if (focusSearch && searchInput) searchInput.focus();
    }
    function close() {
      panel.hidden = true;
      setExpanded(false);
    }
    function isOpen() { return !panel.hidden; }

    // Zoek-icoon: opent het paneel en zet de cursor meteen in het zoekveld
    on(searchToggle, 'click', function (e) {
      e.stopPropagation();
      if (isOpen()) { close(); } else { open(true); }
    });

    // Klik in panel niet laten bubbelen naar document-handler
    on(panel, 'click', function (e) { e.stopPropagation(); });

    // Klik buiten panel = sluiten
    on(document, 'click', function (e) {
      if (!isOpen()) return;
      var onTrigger = triggers.some(function (t) { return e.target === t || t.contains(e.target); });
      if (onTrigger) return;
      if (panel.contains(e.target)) return;
      close();
    });

    // Esc sluit panel
    on(document, 'keydown', function (e) {
      if (e.key === 'Escape' && isOpen()) {
        close();
        searchToggle.focus();
      }
    });
  }

  /* --------- Init --------- */
  function init() {
    initMobileMenu();
    initUtilityDropdown();
    initCartDrawer();
    initProductFormSubmit();
    initNewsletter();
    initQuiz();
    initIngredientsLab();
    initCollectionSort();
    initFilterDrawer();
    initCollectionLoadMore();
    initProductQty();
    initGiftWrap();
    initMegaMenu();
    initBestsellerCarousel();
    initReviewMarquee();
    initProductThumbnails();
    initProductVariantPills();
    trackRecentlyViewed();
    renderRecentlyViewed();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
